export const putUserInfo='PUT_USER_INFO'
export const outUserInfo='OUT_USER_INFO'
